module.exports = __webpack_public_path__ + "static/media/image-placeholder.b1fc033e.png";